import { FC, useState } from 'react';
import { InputWithButtonProps } from 'components';
import axios from 'axios';
import styles from './NewsletterInput.module.css';
import { email } from 'utility/patterns';
import { CheckCircleOutlined } from '@ant-design/icons';

export const NewsletterInput: FC<Partial<InputWithButtonProps>> = (props) => {
  let [loading, setLoading] = useState(null)
  let [error, setError] = useState(null)
  let [isSuccess, setIsSuccess] = useState(null)

  const subscribeToNewsletter = async (e) => {
    e.preventDefault();
    let formData = new FormData(e.currentTarget)
    try {
      setLoading(true);
      setError(null)
      await axios.post(`${process.env.NEXT_PUBLIC_REACT_APP_STRAPI_API_URL}/subscribe`,
        {
          email_address: formData.get("email")
        })
        .then((res) => {
          console.log(res)
          setIsSuccess(true)
          setLoading(false)
        })
        .catch((e) => {
          if (e.response.data.message.title === "Member Exists") {
            setIsSuccess(true)
            setLoading(false)
          } else {
            setIsSuccess(false)
            setLoading(false)
          }
        });
    } catch (error) { console.log(error) }
  }
  return (
    <form className={styles.SignUp} onSubmit={isSuccess ? () => { } : (e) => subscribeToNewsletter(e)}>
      <input pattern={email.pattern} name="email" placeholder="Email address"></input>
      <button className={isSuccess && styles.NewsletterSuccess} disabled={isSuccess}>{!isSuccess && !loading ? '>' : loading ? "..." : <CheckCircleOutlined />}</button>
    </form>
  )
};
